import Axios from "axios"

export const dateTimeFormatter = (time, format) => {
  if (typeof time === 'number') {
    time = new Date(time)
  }
  const year = time.getFullYear()
  const month = time.getMonth()
  const day = time.getDate()
  const hours24 = time.getHours()
  const hours = hours24 % 12 === 0 ? 12 : hours24 % 12
  const minutes = time.getMinutes()
  const seconds = time.getSeconds()
  const milliseconds = time.getMilliseconds()
  const dd = t => ('0' + t).slice(-2)
  const map = {
    YYYY: year,
    MM: dd(month + 1),
    M: month + 1,
    DD: dd(day),
    D: day,
    HH: dd(hours24),
    H: hours24,
    hh: dd(hours),
    h: hours,
    mm: dd(minutes),
    m: minutes,
    ss: dd(seconds),
    s: seconds,
    S: milliseconds
  }
  return format.replace(/Y+|M+|D+|H+|h+|m+|s+|S+/g, str => map[str])
}
export function getBaseUrl() {
  if (!window.location.origin) {
    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  }
  return window.location.origin
}
export function exportFile (urlPath, params, fileName) {
  Axios({
    method: 'post',
    url: urlPath,
    responseType: 'blob',
    data: params,
    headers: {'X-Requested-With': 'XMLHttpRequest'},
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  });
};